import { CModelRepo as cModelRepo } from '../cmodel.repo';


class CModelInternationalController implements angular.IOnInit {
  static $inject = ["cModelRepo"];


  /** @ngInject */
  constructor(private cModelRepo: cModelRepo) {
  }

  $onInit() {
    var that = this;


  }


}

export const cModelInternational: angular.IComponentOptions = {
  template: require('../cmodel.international/cmodel.international.html'),
  controller: CModelInternationalController
};



// WEBPACK FOOTER //
// ./src/app/cmodel/cmodel.international/cmodel.international.ts